export default "__VITE_ASSET__Bqi7SKZL__"